import { render, staticRenderFns } from "./ModuloForm.vue?vue&type=template&id=7b423550&"
import script from "./ModuloForm.vue?vue&type=script&lang=js&"
export * from "./ModuloForm.vue?vue&type=script&lang=js&"
import style0 from "./ModuloForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports